import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper = new Swiper(".mySwiper", {
    slidesPerView: 7,
     breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 7,
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 4,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 3,
      }
    } 
});
var swiper2 = new Swiper(".mySwiper2", {
    thumbs: {
        swiper: swiper,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

$(".section10 ul li").click(function() {
    $(this).toggleClass("active");
    $(this).find(".text").slideToggle();
})
